const ERRORS = {
	REQUIRED: "This field is required.",
	EMAIL: "Please provide a valid email",
	MIN_ONE_EMAIL: "At least one email is required",
	AT_LEAST_ONE: "At least one image is required",
	DATE_FORMAT: "Invalid date format (DD/MM/YYYY)",
	INVALID_START_DATE: "Start date cannot be after end date",
	INVALID_END_DATE: "End date cannot be before start date",
};

export default ERRORS;
